import { define } from "naltatis-preactement";
import { OrdersPage } from "../views/orders/ordersPage.tsx";
import { OrderDetailsPage } from "../views/orders/orderDetailsPage.tsx";
import { InStoreOrderDetailsPage } from "../views/orders/inStoreOrderDetailsPage.tsx";
import { LastOrderFragment } from "../views/orders/lastOrderFragment.tsx";

define(OrdersPage.tagName, () => OrdersPage);
define(OrderDetailsPage.tagName, () => OrderDetailsPage);
define(InStoreOrderDetailsPage.tagName, () => InStoreOrderDetailsPage);
define(LastOrderFragment.tagName, () => LastOrderFragment);
